export const REFRESH_EVERY = 60000; // 1 minute
export const TIME_FORMAT = "HH:mm";

// UTC offset selectable range (hours)
export const MIN_TZ = -12;
export const MAX_TZ = 11;
